import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
	selector: 'app-kamona-pending-modal',
	templateUrl: './kamona-pending-modal.component.html',
	styleUrls: ['./kamona-pending-modal.component.scss']
})
export class KamonaPendingModalComponent implements OnInit {
	@Output() closeModal = new EventEmitter();
	@Input() description: string;
	@Input() title: string;
	@Input() forNewDevice: boolean;
	@Input() useFullButton: boolean;
	@Input() buttonText = 'Close';

	constructor() {
	}

	ngOnInit(): void {
	}

	cancelModal() {
		this.closeModal.emit(true);
	}

}


